import { render, staticRenderFns } from "./BooleanCol.vue?vue&type=template&id=6c3ae508&scoped=true"
import script from "./BooleanCol.vue?vue&type=script&lang=js"
export * from "./BooleanCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3ae508",
  null
  
)

export default component.exports